// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PRadiusUpleftOutlinedSvg from "@fishx/icons-svg/es/asn/PRadiusUpleftOutlined";
import FishxIcon from '../components/FishxIcon';

var PRadiusUpleftOutlined = function PRadiusUpleftOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PRadiusUpleftOutlinedSvg
  }));
};

PRadiusUpleftOutlined.displayName = 'PRadiusUpleftOutlined';
export default React.forwardRef(PRadiusUpleftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PRadiusUpleftOutlined.js
// module id = 3580
// module chunks = 0